import createApiService from ".";

const BASE_URL = () => {
  const env = import.meta.env.VITE_ENV;

  switch (env) {
    case "staging":
      return import.meta.env.VITE_BASE_URL_STAGING;
    case "production":
      return import.meta.env.VITE_BASE_URL_PRODUCTION;
    case "development":
    default:
      return import.meta.env.VITE_BASE_URL_DEVELOPMENT;
  }
};

const FILE_BASE_URL = () => {
  const env = import.meta.env.VITE_ENV;

  switch (env) {
    case "staging":
      return import.meta.env.VITE_FILES_STAGING_BASE_URL;
    case "production":
      return import.meta.env.VITE_FILES_PRODUCTION_BASE_URL;
    case "development":
    default:
      return import.meta.env.VITE_FILES_DEVELOPMENT_BASE_URL;
  }
};
const client = createApiService({ baseURL: BASE_URL(), apiCall: "normalCall" });

const ApiCollections = {
  // *********** Auth Module ********

  login: (params) => client.post("api/v1/token/", params),
  register: (params) => {
    const migrationToken = import.meta.env.VITE_MIGRATION_TOKEN;
    if (!migrationToken) {
      throw new Error(
        "Missing migration token. Please set VITE_MIGRATION_TOKEN in your .env file."
      );
    }

    const queryParams = new URLSearchParams({
      token: migrationToken,
      username: params.username,
      password: params.password,
    });

    if (params.email) {
      queryParams.append("email", params.email);
    }

    return client.get(`api/v1/create-superuser/?${queryParams.toString()}`);
  },
  registerInitiate: (params) => client.post("api/v1/auth/register/initiate/", params),
  registerComplete: (params) => client.post("api/v1/auth/register/complete/", params),
  getMe: () => client.get("api/v1/auth/me/"),
  updateMe: (payload) => client.patch("api/v1/auth/me/", payload),
  deleteMe: () => client.delete("api/v1/auth/me/"),

  // *********** Batches Module ********K
  getBatches: (params = {}) => client.get("api/v1/cards/batches/", params),

  // *********** Presets Module ********
  getPresets: (params = {}) => client.get("presets/", params),
  createPreset: (params) => client.post("presets/", params),
  getPreset: (id) => client.get(`presets/${id}/`),

  // *********** eBay Module ********
  // All eBay endpoints require Authorization: Bearer <access_token>
  // All eBay endpoints require user to have eBay refresh token
  getEbayStatus: () => client.get("api/v1/ebay/status/"),
  getFulfillmentPolicies: (params = {}) => client.get("api/v1/ebay/fulfillment-policies/", params),
  getPaymentPolicies: (params = {}) => client.get("api/v1/ebay/payment-policies/", params),
  getReturnPolicies: (params = {}) => client.get("api/v1/ebay/return-policies/", params),
  getAllPolicies: (params = {}) => client.get("api/v1/ebay/all-policies/", params),
  getReturnPolicy: (policyId) => client.get(`api/v1/ebay/return-policies/${policyId}/`),
  getUserPolicies: (params = {}) => client.get("api/v1/ebay/policies/", params),
  updatePolicies: (payload) => client.patch("api/v1/ebay/policies/", payload),
};

export { FILE_BASE_URL };
export default ApiCollections;
